<template>
  <div class="standard-grid-wrapper">
    <standard-grid-layout
      :grid-gap="gridGap"
      :grid-columns="gridColumns"
      :items="gridItems"
    >
      <template v-slot:item="{ item, key }">
        <split-content-card
          :key="key"
          :content="item"
          :aspect="aspectRatio"
        />
      </template>
    </standard-grid-layout>
  </div>
</template>

<script>
import standardGridLayout from './grids/standard-grid-layout.vue'
import splitContentCard from './grids/split-content-card.vue'

export default {
  name: 'standard-grid',
  components: {
    standardGridLayout,
    splitContentCard
  },
  props: {
    filestore: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    widget: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data() {
    return {
      // onlyOnHover: false, //if set, we only show play the video on hover

    }
  },
  computed: {
    settings() {
      return this.widget.widgetSettings.standardGrid
    },
    gridGap() {
      return this.settings.gridGap
    },
    gridColumns() {
      return this.settings.gridColumns
    },
    aspectRatio() {
      return this.settings.imageAspectRatio
    },
    gridItems() {
      // const a = this.widget.standardGridItems
      // debugger
      return this.widget.standardGridItems
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.standard-grid-wrapper{
  max-width: var(--standard-grid-wrapper-width, 1140px);
  margin: 0 auto;
  padding: 0 15px;
}
</style>
